import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";

import AppCard from "../../components/AppCard/AppCard";
import ContainedButton from "../../components/Buttons/ContainedButton";
import Footer from "../../components/Layout/Footer";
import Header from "../../components/Layout/Header";
import Layout from "../../components/Layout/Layout";
import OutlinedButton from "../../components/Buttons/OutlinedButton";
import React from "react";
import img1 from "../../assets/images/our-story-img1.png";
import imgp from "../../assets/images/our-story-imgp.png";

import styles from "./styles/ourStory.module.css";

export default function OurStory() {
  const { t } = useTranslation();
  const theme = useTheme();
  const ourStory = {
    title: "Our Story",
    subtitle: "45 Years Spent Building Personalized Mattresses",
    descriptionP1:
      "We’ve been in mattress manufacturing for 4 decades and have directly witnessed the impact of ‘one size fits all mattresses’ on our customer’s sleep. Our customers, usually couples, come to us knowing their individual needs are more unique than what the consumable mattress industry can offer. ",
    descriptionP2:
      "By building for our boutique clients and providing thousands of one on one experiences with our sleep experts, we have perfected the evrbase, our best selling mattress base ready for your personalizations",
  };
  const ourMission = {
    title: "Our Mission",
    subtitle:
      "The Mission Of Evrbed Is To Create The Best Sleep Possible By Delivering Innovative, Environmentally Friendly, Mattress Designs To All Sleepers.",
    description: "Learn more about the evrgreen commitment ",
  };
  const ourValues = [
    {
      icon: "light",
      title: "innovation",
      bgColor: theme.COLORS.BLUE.darkBlueGreen,
      description:
        "We are proud to bring a new modular approach to mattress personalization and the mattress personalization and the mattress lifecycle. We carefully select core materials that can last a lifetime paired with high quality, interchangeable components.",
    },
    {
      icon: "bell",
      title: "sustainability",
      bgColor: theme.COLORS.GREEN.green,
      description:
        "We are committed to our evrgreen program and not producing addtional waste with 'throw away policies'.",
    },
    {
      icon: "tree",
      title: "customer care",
      bgColor: theme.COLORS.BLUE.lightBlue3,
      color: theme.COLORS.BLUE.darkBlueGreen,
      description:
        "We start caring about your needs when you start building your mattress, not just when you go to return. We are committed to your entire journey with evrbed.",
    },
  ];
  const intro = {
    content:
      "Everyone is unique and there isn't one mattress that fits all shapes and sizes. We want to deliver the highest quality mattress personalizad to  optimize sleep. In todays culture too many things are simply disposable, and we believe in things that last, and thats why we design the way we do.",
    name: "-Colin Crump, Founder",
  };
  const renderAppCards = ourValues.map((value, index) => {
    return (
      <AppCard
        key={index}
        {...value}
        title={t(value.title)}
        description={t(value.description)}
      />
    );
  });
  return (
    <Layout width="100%">
      <Header  showCart={true} cartIconColor={"white"} />
      <div className={styles.pageWrap}>
        <div className={styles.container}>
          <div>
            <h2>{t(ourStory.title)}</h2>
            <img src={img1} alt="our story" className={styles.img1} />
          </div>
          <h5>{t(ourStory.subtitle)}</h5>
          <p style={{}}>{t(ourStory.descriptionP1)}</p>
          <p>{t(ourStory.descriptionP2)}</p>
          <OutlinedButton
            text="view evrbase"
            variant="outlined"
            color="rgb(0 0 0 / 0%)"
            borderColor="var(--app-color)"
          />
          <div className={styles.buildBtn}>
            <ContainedButton>
              {t("BUILD MY BED")}
            </ContainedButton>
          </div>
          <div className={styles.ourMissionSection}>
            <div>
              <h3>{t(ourMission.title)}</h3>
            </div>
            <h5>{t(ourMission.subtitle)}</h5>
            <p>{t(ourMission.description)}</p>
            <div>
              <ContainedButton text="build my bed" >
                {t("our commitment")}
              </ContainedButton>
            </div>
          </div>
          <div className={styles.ourValues}>
            <div>
              <h3>Our Values</h3>
              {renderAppCards}
              <div className={styles.cardContainer}>
                <div className={styles.card}>
                  <img src={imgp} alt="our story" className={styles.imgp} />
                  <div className={styles.blockRow}>
                    <div className={styles.block1} />
                    <div className={styles.block2} />
                  </div>
                  <div className={styles.content}>{t(intro.content)}</div>
                  <div className={styles.introName}>{t(intro.name)}</div>
                </div>
                <div className={styles.block3} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer showMenuButton={true} styles={{ zIndex: 1100 }}></Footer>
    </Layout>
  );
}
